<template>
  <div class="container o-form-page">
    <o-working-overlay :working="working"></o-working-overlay>

    <o-section :level="0" :title="title" @click="enableDebug($event)">
      <item-form
        :form-state="formState"
        :item="item"
        :current-state="current_state"
        :state-id="state"
        :server-errors="serverErrors"
        :submitting.sync="submitting"
        @templateSelected="templateSelected"
        @can-save="canSave"
        @buttons-loaded="onButtonsLoaded"
      ></item-form>
    </o-section>

    <o-action-buttons
      :create="create"
      :form-state="formState"
      :item="item"
      :show-create-and-new="!hideCreateAndNewButton"
      :hide-delete="hideDeleteButton"
      :hide-save="hideUpdateButton"
      :hide-save-and-close="hideSaveAndClose"
      :label-for-create="labelForCreate"
      :label-for-update="labelForUpdate"
      :save-and-close-label="saveAndCloseButtonLabel"
      :save-and-new-label="saveAndNewButtonLabel"
      :can-save="check_can_save"
      @delete="doDeleteItem"
      @save="doSave"
      @saveAndClose="doSaveAndClose"
      @saveAndNew="doSaveAndNew"
    >
      <b-button v-if="item.id" variant="primary" @click="downloadPDF()"
        >Download PDF</b-button
      >
      <workflow-buttons
        v-if="current_state"
        :state="current_state"
        :onsave="_doSave"
        :loaded-buttons="workflowButtons"
        @close="closeMe"
      ></workflow-buttons>
    </o-action-buttons>
  </div>
</template>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateFormPageMixin,
  CreateGroupPermissionMixin,
  UnsavedMixin,
} from "../../../../vue-ocom/mixins";
import ItemForm from "../components/ItemForm.vue";
import OActionButtons from "../../../../vue-ocom/components/forms/OActionButtons.vue";
import OSection from "../../../../vue-ocom/components/layout/OSection.vue";
import OWorkingOverlay from "../../../../vue-ocom/components/OWorkingOverlay.vue";
import { fileDownload } from "../../../../vue-ocom/filesystem/fileDownload.js";
import { mapGetters } from "vuex";
import WorkflowButtons from "../../components/WorkflowButtons.vue";
import { merge, isEmpty } from "lodash";
import router from "../../../../router";

export default {
  mixins: [
    UnsavedMixin,
    CreateFormPageMixin("FormEntry", "form_entry"),
    CreateGroupPermissionMixin("FormEntry"),
  ],
  components: {
    OSection,
    OWorkingOverlay,
    OActionButtons,
    ItemForm,
    WorkflowButtons,
  },
  props: {
    state: { type: [Number, String], default: "" },
  },
  data() {
    return {
      submitting: false,
      template_used: null,
      save_ok: true,
      states: [], // initialised in get_my_states()
      workflowButtons: null,
    };
  },
  methods: {
    onButtonsLoaded(buttons) {
      this.workflowButtons = buttons;
    },
    closeMe(data) {
      if ("locked" in data) {
        this.item.is_locked = data["locked"]; // propogate loccked value here
      }
      merge(this.item.data, data.data || {});

      this.doSaveAndClose();
    },
    check_can_save() {
      return this.save_ok && !!this.template_used;
    },
    canSave(val) {
      this.save_ok = val;
    },
    user_must_submit() {
      if (this.item.form_template_version) {
        return (
          this.item.form_template_version.option_form_is_submitted === true
        );
      }
      return false;
    },
    OnCreateNew(item) {
      // Template_version picked in FTemplateSelect

      if ("other_id" in this.$route.query) {
        item.other_id = parseInt(this.$route.query.other_id);
      }
      if ("other_name" in this.$route.query) {
        item.other_name = this.$route.query.other_name;
      }
    },
    templateSelected(template_used) {
      this.template_used = template_used;
      if (!this.item.form_template_version) {
        this.item.form_template_version = this.template_used; // assign form_template_version
      }
    },
    hookSave(item, created) {
      const vm = this;

      function checkSubmitting() {
        // if Submitting then call the Actions, else just save as it changed.
        if (vm.submitting) {
          if (vm.template_used) {
            vm.saveItem(item); // update database
          }
        } else {
          vm.saveItem(item); // update database
        }
      }

      if (created) {
        if (this.template_used) {
          checkSubmitting();
        }
      } else {
        if (this.template_used) {
          checkSubmitting();
        }
      }
    },
    get_my_states() {
      const vm = this;

      if (!("current_user_states" in this.item)) {
        return; // Nothing to do probably New
      }

      const states = this.item.current_user_states;

      if (states.length > 0) {
        // There are states for this Form Entry, so reload as this current state for this user.
        // Replace current route to avoid keeping it in browser history
        router.replace({
          name: "form_entry.edit",
          params: { id: vm.item.id, state: states[0].id },
        });
      }
    },
    downloadPDF() {
      var url = `${process.env.VUE_APP_ROOT_API}/forms247/entry/pdf/${this.item.id}/`;
      var filename = "form_entry.pdf";

      if (this.token) {
        url = url + "?jwt=" + encodeURIComponent(this.token);
      }

      if (
        this.item
          .form_template_version__form_template_versions__form_template__name
      ) {
        filename =
          this.item
            .form_template_version__form_template_versions__form_template__name +
          "-" +
          this.item.id;
      }

      // this.axios.defaults.headers.common["Authorization"] = `Bearer ${this.token}`;
      this.axios
        .get(url, { responseType: "blob" })
        .then(function (response) {
          if (response.data) {
            fileDownload(
              response.data,
              filename,
              response.headers["content-type"]
            );
          }
        })
        .catch(function (error) {});
    },
  },
  watch: {
    item: function (newVal, oldVal) {
      if (!this.state && !this.create) {
        this.get_my_states();
      }
    },
    state: function (newVal, oldVal) {
      if (newVal && this.item && this.item.id) {
        router.push({
          name: "form_entry.edit",
          params: { id: this.item.id, state: newVal },
        });
      }
    },
  },
  computed: {
    ...mapGetters("AuthModule", ["currentUser", "token"]),
    current_state() {
      if (this.item) {
        if (isEmpty(this.item.states || {})) {
          return ""; // No states - assumed none left or all completed
        } else {
          return this.state; // has state from the Props
        }
      }
      // Was used but not any more
      return this.state; // from PROPs
    },
    current_form_template_version() {
      var form_template_version = this.item.form_template_version_instance;
      if (!form_template_version) {
        form_template_version = this.template_used;
      }

      return form_template_version;
    },
    hideCreateAndNewButton() {
      var form_template_version = this.current_form_template_version;

      if (form_template_version) {
        if (form_template_version.option_hide_and_new_button != null) {
          return form_template_version.option_hide_and_new_button;
        }
      }

      if (this.item && this.item.is_closed) {
        return true;
      }

      return false;
    },
    hideUpdateButton() {
      if (this.item && this.item.is_closed) {
        return true;
      }

      return false;
    },
    hideSaveAndClose() {
      var form_template_version = this.current_form_template_version;

      if (form_template_version) {
        if (form_template_version.option_hide_and_close_button != null) {
          return form_template_version.option_hide_and_close_button;
        }
      }

      if (this.item && this.item.is_closed) {
        return true;
      }

      return false;
    },
    hideDeleteButton() {
      var form_template_version = this.current_form_template_version;

      if (form_template_version) {
        if (form_template_version.option_hide_delete_button != null) {
          return form_template_version.option_hide_delete_button;
        }
      }

      if (this.item && this.item.is_closed) {
        return true;
      }

      return false;
    },
    mainButtonLabel() {
      const ftv = this.current_form_template_version;
      if (this.create) {
        return (ftv && ftv.option_create_button_label) || "Create";
      }
      if (
        this.user_must_submit &&
        this.item.submitted_user &&
        !this.item._was_submitted
      ) {
        return (ftv && ftv.option_submit_button_label) || "Submit";
      }
      return (ftv && ftv.option_update_button_label) || "Update";
    },
    andCloseSuffix() {
      const ftv = this.current_form_template_version;
      return (ftv && ftv.option_and_close_suffix) || "And Close";
    },
    andNewSuffix() {
      const ftv = this.current_form_template_version;
      return (ftv && ftv.option_and_new_suffix) || "And New";
    },
    labelForCreate() {
      return this.mainButtonLabel;
    },
    labelForUpdate() {
      return this.mainButtonLabel;
    },
    saveAndCloseButtonLabel() {
      return this.mainButtonLabel + " " + this.andCloseSuffix;
    },
    saveAndNewButtonLabel() {
      return this.mainButtonLabel + " " + this.andNewSuffix;
    },
    title() {
      if (this.create) {
        return "Create Form Entry";
      }

      return "Edit Form Entry";
    },
  },
};
</script>
